import axiosBase from "@/api/axiosBase";

const state = {
    allProjs:[],
    allProjsNum: 0,
}

const getters = {
    getAllProjsChange: state=>state.allProjsNum
}

const actions = {
    //获取所有投影坐标系
    getAllProjs({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/gis/allProj'
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                else{
                    commit('setAllProjs', res.data.data);
                }
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取已投影坐标系文件
    getAllFileProj({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/gis/allFileProj'
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取geojson
    getFileGeojson({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/gis/geojson/' + data.fileId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取字段匹配结果
    getMatchField({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/gis/find/matchRes',
                data:[data.fileId]
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取标准字段
    getBaseField({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/gis/standard'
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //更新字段匹配
    updateMatchField({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/gis/matchRes',
                data:{
                    "file_id": data.fileId,
                    "data_type": data.dataType,
                    "match_map": data.matchMap
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //自动匹配投影坐标系
    autoMatchProj({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/gis/autoMatchProjcs',
                data:{
                    "fileId": data.fileId,
                    "lonMax": data.lonMax,
                    "lonMin": data.lonMin,
                    "latMax": data.latMax,
                    "latMin": data.latMin
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //保存投影偏移旋转量
    saveGisProj({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/gis/saveProj',
                data:{
                    "file_id": data.fileId,
                    "projcs_id": data.projcsId,
                    'list':data.list
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取投影偏移旋转量
    getGisProj({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/gis/offsetProj/' + data.fileId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //拾取高程
    getEle({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/gis/pickDem',
                data:{
                    "dem_id": data.dem_id,
                    "ids": data.ids,
                    "lats": data.lats,
                    "lons": data.lons
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    // getGeoTiffFileUrl({dispatch, commit}, data){
    //     return new Promise((resolve,reject)=>{
    //         axiosBase({
    //             method:'GET',
    //             url:'/model/file/presignedUrl/' + data.fileId
    //         }).then(res=>{
    //             if(res.data.code != 200){
    //                 commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
    //             }
    //             resolve(res)
    //         })
    //         .catch(error=>{
    //             commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
    //             resolve({data:{code:500}})
    //         })
    //     })
    // },
    //获取tif的范围
    getGeoTiffFileRange({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/gis/tifRange/' + data.fileId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取dem的tif数据
    getGeoTiffData({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/tif/' + data.fileId,
                headers:{
                    'Content-Type': 'image/tiff; charset=utf-8'
                },
                responseType: 'blob'
            }).then(res=>{
                if(res.status != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.statusText}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //根据ids获取geojson
    getGeojsonByFID({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/basedata/gis/geojson_by_ids',
                data:{
                    "file_id": data.file_id,
                    "by_field": data.by_field,
                    "ids": data.by_field == 'FID' ? data.ids : data.ids.map(a=>parseInt(a))
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    }
}

const mutations = {
    setAllProjs(state, projs){
        state.allProjs = projs;
        state.allProjsNum++;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}